import {ProductBuyMobile} from 'modules/product-card/components/ProductBuyMobile';
import {FC, useCallback, useRef} from 'react';
import style from './style.module.scss';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {useIsProductAvailableForUser} from 'modules/products/hooks/useIsProductAvailableForUser';
import {useUpButtonOffsetForStickyPanel} from 'components/UpButton/hooks/useUpButtonOffsetForStickyPanel';
import {showModal} from 'modules/modals/thunks';
import {MODALS} from 'modules/modals/constants';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {Button} from 'components/Button';
import {Typography} from 'components/Typography';
import {ProductShowSimilarButton} from 'modules/product-card/components/ProductShowSimilarButton';
import {useElementHeight} from 'core/hooks/useElementHeight';
import {RUNTIME_CSS_VARS} from 'core/constants';

export const ProductBuyMobilePanel: FC = () => {
    const productData = useAppSelector(selectProductData);
    const {canBuy, canReserve, similar} = productData || {};
    const dispatch = useAppDispatch();

    const isProductAvailable = useIsProductAvailableForUser(canBuy, canReserve);

    const handleClick = useCallback(() => {
        dispatch(showModal(MODALS.PRODUCT_NOTIFY_AVAILABLE.name));
    }, [dispatch]);

    useUpButtonOffsetForStickyPanel();

    const panelRef = useRef<HTMLDivElement>(null);
    useElementHeight(panelRef, RUNTIME_CSS_VARS.productBuyMobilePanelHeight);

    if (!isProductAvailable && !similar) {
        return (
            <div className={style.main} ref={panelRef}>
                <Button className={style.button} isStretched={true} onClick={handleClick} theme={'secondary'}>
                    <Typography variant={'label-16-r'}>Узнать о наличии</Typography>
                </Button>
            </div>
        );
    }

    if (!isProductAvailable && similar) {
        return (
            <div className={style.main} ref={panelRef}>
                <ProductShowSimilarButton />
            </div>
        );
    }

    return (
        <div className={style.main} ref={panelRef}>
            <ProductBuyMobile />
        </div>
    );
};
